<template>
  <div>
         <div v-if="!global.isPhone()" class="container logo-box">
        <!-- <a href="/" class="logo" title="测评系统"><img :src="`/static/images/logo.png?t=${Math.random()}`" alt="logo"></a> -->
         <el-button  @click="$router.push('/')" class="personcenter" round >首页</el-button>
           </div>
    <div>
        <section>
            <div class="search-container">
                <div v-if="global.isPhone()">
                    <img src="/static/images/sdsd.png" alt="一体化人才测评公共服务平台" class="logo_svg center">
                    <div class="search">
                        <div class="search-box el-input el-input--30">
                            <!----><input type="text" autocomplete="off" placeholder="输入学号查询测评成绩" v-model="cardid"
                                class="el-input__inner">
                        </div> <img id="search-icon" src="/static/images/search.svg" @click="search()" alt="搜索" class="search-icon">
                    </div>  
                </div>
                <el-card class="box-card" v-else>
                        <img
                        class="pic1"
                        referrerpolicy="no-referrer"
                        src="/static/images/sdsd.png"
                        />
                        <el-input v-model="cardid" placeholder="输入学号查询测评成绩" class="input_data"></el-input>
                        <div class="section1 flex-col"  @click="search()">
                        <span class="info1">立即查询</span>
                        </div>
                </el-card>
            </div>
        </section>
	</div>
	<center>
		<div style="font-size: 10px">Copyright © 2022 www.zhcpw.org.cn 京ICP备18062373号-6-1</div>
	</center>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
        metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=no, initial-scale=${1.0}, maximum-scale=${1.0}, minimum-scale=${1.0}`}
      ]
    },
  props: {},
  components: {},
  data () {
    return {
        global,
        cardid:""
    };
  },

  created() {},

  methods: {
      search(){
        this.$axios.get(`/api/users/findMeByCardId?cardid=${this.cardid}`).then(res => {
            if(res.data){
                this.$router.push(`/queryResult?cardid=${this.cardid}`);
            }
        });
      }
  },

  computed: {},

  mounted() {},

  watch: {}
}

</script>
<style scoped>
.section1 {
  background-color: #4462CF;
  border-radius: 35px;
  height: 71px;
  width: 538px;
  padding: 28px 0 0 231px;
  margin:auto;
  margin-top: 30px;
}
.info1 {
  width: 75px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}

.input_data{
    width: 538px !important;
height: 71px;
border: 1px solid #4462CF;
border-radius: 36px;
margin: auto;
margin-top:80px;
}
.box-card{
width: 660px;
height: 507px;
background: #F0F0F0;
border-radius: 10px;
margin:auto;
}
.layer5 {
  width: 254px;
  height: 89px;
  /* margin: -351px 0 367px 203px; */
  margin:auto;
  margin: top 30px;
}
.pic1 {
  width: 496px;
 height: 82px;
  margin:auto;
  margin-top: 30px;
}


.search-container {
text-align: center;
background: url(/static/img/deebeirjign.png);
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
      padding: 11rem 2rem 0;
    width: 100%;
    background-color:#4462cf;
}
@media screen and (min-width: 640px) {
    /deep/ .el-input__inner{
        border-radius: 36px;
        width:100%;
        height:69px;
        font-size: 18px !important;
            background-color: #ffffff;
    }
    .search-container {
            padding: 261px 2rem 0;
    }
}
.logo_svg {
    height: 8.75rem;
    margin: 0 0.85rem 3.3rem;
    width: 20.05rem;
}

.search {
    position: relative;
}

.search-box {
    background-color: #fff;
    border: none;
    border-radius: 1.2rem;
    box-sizing: border-box;
    color: #666;
    font-family: MicrosoftYaHei;
    font-size: .8rem;
    height: 2.5rem;
    line-height: .75rem;
    outline: none;
    padding: 0 2.9rem 0 1.05rem;
    width: 16.75rem;
    
    
}

.search-box::-moz-placeholder {
    color: #c9c9c9;
    font-family: MicrosoftYaHei;
    font-size: .6rem
}

.search-box:-ms-input-placeholder {
    color: #c9c9c9;
    font-family: MicrosoftYaHei;
    font-size: .6rem
}

.search-box::placeholder {
    color: #c9c9c9;
    font-family: MicrosoftYaHei;
    font-size: .6rem
}

.search-icon {
    height: 1.35rem;
    position: absolute;
    right: .75rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1.35rem
}

 .el-input__inner {
    border: 0;
    height: 2.5rem;
    padding: 0
}

.el-input {
            display: inline-block;
            font-size: 14px;
            position: relative;
            width: 100%
        }

        .el-input::-webkit-scrollbar {
            width: 6px;
            z-index: 11
        }

        .el-input::-webkit-scrollbar:horizontal {
            height: 6px
        }

        .el-input::-webkit-scrollbar-thumb {
            background: #b4bccc;
            border-radius: 5px;
            width: 6px
        }

        .el-input::-webkit-scrollbar-corner,
        .el-input::-webkit-scrollbar-track {
            background: #fff
        }

        .el-input::-webkit-scrollbar-track-piece {
            background: #fff;
            width: 6px
        }

        .el-input .el-input__clear {
            color: #c0c4cc;
            cursor: pointer;
            font-size: 14px;
            transition: color .2s cubic-bezier(.645, .045, .355, 1)
        }

        .el-input .el-input__clear:hover {
            color: #909399
        }

        .el-input .el-input__count {
            align-items: center;
            color: #909399;
            display: inline-flex;
            font-size: 12px;
            height: 100%
        }

        .el-input .el-input__count .el-input__count-inner {
            background: #fff;
            display: inline-block;
            line-height: normal;
            padding: 0 5px
        }
</style>